import React from 'react';
import { Button, Props as ButtonProps } from '@/components/button';
import { StyleSheet, Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  buttonProps: ButtonProps;
  textContent: string;
}

export const ActionToastContent: React.FC<Props> = ({
  buttonProps,
  textContent,
}) => {
  return (
    <View style={styles.toast}>
      <Text style={[TYPOGRAPHY.toast, styles.toastText]}>{textContent}</Text>
      <Button size="small" {...buttonProps} />
    </View>
  );
};

const styles = StyleSheet.create({
  toast: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  toastText: {
    flexShrink: 1,
    marginRight: 12,
  },
});
